import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'

export type KambiCouponBetStatus = 'Won' | 'Pending' | 'NoPayout' | null

export function getKambiCouponBetStatus(
  bet: KambiHistoryCoupon['bets'][0] | undefined
): KambiCouponBetStatus {
  if (!bet) return null

  switch (bet.betStatus) {
    case 'WON':
    case 'CASHED_OUT':
    case 'CLAIMED':
      return 'Won'
    case 'LOST':
    case 'VOID':
    case 'REJECTED':
    case 'REJECTED_BY_AAMS':
    case 'CANCELLED':
    case 'EXPIRED':
      return 'NoPayout'
    case 'OPEN':
    case 'PLACED':
    case 'WAITING_FOR_APPROVAL':
    case 'WAITING_FOR_APPROVAL_BY_AAMS':
    default:
      return 'Pending'
  }
}
